import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { asyncScheduler } from 'rxjs';
import { EmployeeStaffActionField } from '@app/models/payroll';

export const disableIf = (control: AbstractControl, disable: boolean | (() => boolean)): void => {
	if ((typeof disable === 'boolean' && disable) || (typeof disable === 'function' && disable())) {
		control.disable();
	} else {
		control.enable();
	}
};

export const getFormField = (columnName: string, fields: FormlyFieldConfig[]): FormlyFieldConfig => {
	for (const field of fields) {
		if (field.fieldGroup) {
			for (const subField of field.fieldGroup) {
				if (subField.key === columnName || subField.id === columnName) {
					return subField;
				}
				const found = getFormField(columnName, field.fieldGroup);
				if (found) {
					return found;
				}
			}
		}
	}
};

export const getActionField = (columnName: string, fields: EmployeeStaffActionField[]): EmployeeStaffActionField =>
	fields.find((field) => field.ColumnName === columnName);

export const getAllFormField = (fields: FormlyFieldConfig[]): FormlyFieldConfig[] => {
	const result: FormlyFieldConfig[] = [];
	for (const field of fields) {
		if (field.fieldGroup) {
			result.push(...getAllFormField(field.fieldGroup));
		}
		if (field.key) {
			result.push(field);
		}
	}
	return result;
};

export const scrollToToolBar = () => {
	asyncScheduler.schedule(() => {
		const el = document.querySelector('.mat-toolbar');
		el.scrollIntoView({ block: 'start', behavior: 'smooth' });
	});
};

export const scrollToClass = (className: string) => {
	asyncScheduler.schedule(() => {
		const el = document.querySelector(className);
		el?.scrollIntoView({ block: 'start', behavior: 'smooth' });
	});
};
